/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CardDTO,
    CardDTOFromJSON,
    CardDTOFromJSONTyped,
    CardDTOToJSON,
} from './CardDTO';

/**
 * 
 * @export
 * @interface CardWithHistoryDTO
 */
export interface CardWithHistoryDTO {
    /**
     * 
     * @type {CardDTO}
     * @memberof CardWithHistoryDTO
     */
    current?: CardDTO;
    /**
     * 
     * @type {Array<CardDTO>}
     * @memberof CardWithHistoryDTO
     */
    history?: Array<CardDTO>;
}

export function CardWithHistoryDTOFromJSON(json: any): CardWithHistoryDTO {
    return CardWithHistoryDTOFromJSONTyped(json, false);
}

export function CardWithHistoryDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): CardWithHistoryDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'current': !exists(json, 'current') ? undefined : CardDTOFromJSON(json['current']),
        'history': !exists(json, 'history') ? undefined : ((json['history'] as Array<any>).map(CardDTOFromJSON)),
    };
}

export function CardWithHistoryDTOToJSON(value?: CardWithHistoryDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'current': CardDTOToJSON(value.current),
        'history': value.history === undefined ? undefined : ((value.history as Array<any>).map(CardDTOToJSON)),
    };
}

